module.exports = __webpack_public_path__ + "static/img/sally-and-octavia.44d4f39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sally-and-octavia.jpg
// module id = 345
// module chunks = 0